
import store from "@/store";
import { Options, Vue } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import Menu from "@/components/Menu.vue";
import Tabs from "@/components/Tabs.vue";
import { MenuData } from "@/script/core/base/MenuData";
import bus from "@/script/core/util/Bus";
import { User } from "@/script/apps/system/entity/SystemEntity";
import { ElMessage, ElNotification } from "element-plus";
import { UserService } from "@/script/apps/system/service/UserService";
import { ConfigService } from "@/script/apps/system/service/ConfigService";
import { AuthService } from "@/script/apps/system/service/AuthService";
import { DictService } from "@/script/apps/system/service/DictService";

@Options({
  components: {
    Menu,
    Tabs,
  },
})
export default class Home extends Vue {
  private title = "";
  private copyright = "";
  private version = "";

  private username = "";

  private user: User = {};

  private dialogVisible = false;

  private rules = {
    oldPassword: [{ required: true, message: "请输入原密码", trigger: "blur" }],
    password: [{ required: true, message: "请输入新密码", trigger: "blur" }],
    password2: [
      { required: true, message: "请再次输入新密码", trigger: "blur" },
    ],
  };

  created() {
    this.username = store.getters.loginUser.name;
    this.user.id = store.getters.loginUser.id;
    this.user.name = store.getters.loginUser.name;

    const config = new ConfigService();
    config.loadValue("app-name").then((result: any) => {
      this.title = result.data.itemValue;
    });
    config.loadValue("copyright").then((result: any) => {
      this.copyright = result.data.itemValue;
    });
    config.loadValue("app-version").then((result: any) => {
      this.version = result.data.itemValue;
    });

    new DictService().init();
  }

  quit() {
    store.dispatch("changeLoginToken", "");
    store.dispatch("changeLoginUser", undefined);
    store.dispatch("changeLoginState", 0);

    sessionStorage.clear();

    this.$router.push("/login");
  }

  openChangePassword() {
    this.dialogVisible = true;
  }

  changePassword() {
    const self = this;
    (this.$refs.formPassword as any).validate((valid: boolean) => {
      if (valid) {
        if (this.user.password !== this.user.password2) {
          ElMessage.error("两次密码录入不一致，请重新录入！");
          return;
        }
        const userService = new UserService();
        userService.changePassword(
          this.user,
          function (result: any) {
            ElNotification({
              type: "success",
              title: "修改密码成功",
              message: "请您重新登录系统！",
            });
            self.dialogVisible = false;
            self.$router.push({ path: "/login" });
          },
          function (error: Error) {
            ElMessage.error("修改密码失败，失败原因：" + error.message);
          }
        );
      } else {
        return false;
      }
    });
  }
}
